import MeApi from './me';
import GovernmentFollowersApi from './government-followers';
import UserNotificationsApi from './notifications';

export default {
  me: MeApi,
  notifications: UserNotificationsApi,
  governmentFollowers: GovernmentFollowersApi,
};
